var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHexagonPaperSheet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 134.246,
    height: 162.63
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "hexagon-paper-sheet_svg__b",
    x1: 0.004,
    y1: 0.506,
    x2: 0.999,
    y2: 0.506,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#83a6ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5a78ff"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "hexagon-paper-sheet_svg__a",
    x: 0.763,
    y: 7.09,
    width: 131.265,
    height: 155.54,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#657a93",
    floodOpacity: 0.18
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": 13
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path",
    d: "M134.247 46.818V100.9a13.869 13.869 0 01-.144 2.439 19.674 19.674 0 01-9.816 14.776l-47.059 26.969a19.619 19.619 0 01-14.728 2.008 20.543 20.543 0 01-5.2-2.008l-47.2-27.113A19.968 19.968 0 010 100.757V46.818A19.678 19.678 0 019.96 29.6l47.2-26.969A19.982 19.982 0 0172.032.628a25.8 25.8 0 015.2 2.008L124.286 29.6a20.041 20.041 0 019.96 17.214z",
    fill: "#eaeef9"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": 47
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(.002 -.004)",
    filter: "url(#hexagon-paper-sheet_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path",
    d: "M99.025 29.09H33.76v89.54h65.265z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path",
    d: "M42.376 54.749a.876.876 0 01-.811-.81.868.868 0 01.811-.81h47.935a.867.867 0 01.811.81.875.875 0 01-.811.81zM42.376 60.829a.868.868 0 01-.811-.81.876.876 0 01.811-.81h47.935a.875.875 0 01.811.81.867.867 0 01-.811.81zM42.376 66.919a.877.877 0 01-.811-.82.876.876 0 01.811-.81h47.935a.875.875 0 01.811.81.877.877 0 01-.811.82zM42.376 73.099a.868.868 0 01-.811-.81.868.868 0 01.811-.81h47.935a.867.867 0 01.811.81.867.867 0 01-.811.81zM42.376 79.179a.868.868 0 01-.811-.81.876.876 0 01.811-.81h47.935a.875.875 0 01.811.81.867.867 0 01-.811.81zM42.376 85.269a.876.876 0 01-.811-.81.868.868 0 01.811-.81h21.08a.867.867 0 01.81.81.875.875 0 01-.81.81z",
    fill: "#dae1ed"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path",
    d: "M77.542 39.439H55.145a.915.915 0 010-1.83h22.4a.915.915 0 010 1.83zM71.867 44.199H60.821a.9.9 0 01-.912-.91.9.9 0 01.912-.91h11.046a.9.9 0 01.912.91.9.9 0 01-.912.91z",
    fill: "#ced7e2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.314 15.324a.8.8 0 01.2-1.02 13.863 13.863 0 001.419-1.111C-.293 10.454-.6 5.585 1.024 2.444 2.645-.5 6.193-.806 7.51 1.634a6.221 6.221 0 01.506 4.05 13.239 13.239 0 01-3.141 7v.1a11.994 11.994 0 004.661-1.52.552.552 0 00.3-.51c.1-2.53-.3-3.54 1.115-5.269a1.887 1.887 0 012.23-.51A2.223 2.223 0 0114.6 6.8a4.025 4.025 0 01-1.115 3.351c-1.723 1.92-2.128 1.309-1.723 2.53.1.41.507.2.709.1a11.445 11.445 0 001.824-1.32c1.52-1.62 2.027-3.75 3.649-3.34 1.013.3 1.115 1.32 1.317 2.74A5.658 5.658 0 0121.6 8.324a.789.789 0 011.115.71.767.767 0 01-.507.71c-.913.51-1.216 1.72-2.026 2.64a1.22 1.22 0 01-2.23-.41c-.2-.61-.2-1.22-.4-1.931a43.126 43.126 0 01-2.839 3.351 4.532 4.532 0 01-2.432 1.12 1.725 1.725 0 01-2.128-1.42.319.319 0 01-.1-.21c-.1 0-2.837 1.02-3.243 1.12a18.862 18.862 0 01-2.635.2 2.768 2.768 0 00-.912 0c-.2.1-.1 0-1.723 1.319a.9.9 0 01-.537.175.747.747 0 01-.689-.374z",
    transform: "translate(67.195 92.965)",
    fill: "url(#hexagon-paper-sheet_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M48.194 108.439a4.485 4.485 0 00-2.432-1.22c-1.013-.1-1.925-.2-2.23-1.319a2.215 2.215 0 01-.1-.81 4.021 4.021 0 00-.913-2.021c-.709-.82-1.214-1.53-.709-2.439.608-1.01 1.216-1.42 1.216-2.63a3.182 3.182 0 01.1-1.02 1.833 1.833 0 011.724-1.42c.3 0 .607-.1.912-.1 1.013-.1 1.317-.81 2.635-1.32a1.32 1.32 0 011.216.1c.3.211.608.41 1.014.71.912.71 1.52.41 2.837.81a1.553 1.553 0 011.014 1.22 5.36 5.36 0 00.405 1.83c.507 1.01 1.519 1.52 1.418 2.63a1.073 1.073 0 01-.2.61 7.868 7.868 0 00-1.216 2.23 2.244 2.244 0 00-.1.81 1.7 1.7 0 01-.608 1.42c-1.217 1.219-2.331.31-3.446 1.419a2.478 2.478 0 01-1.658.807 1.43 1.43 0 01-.879-.297z",
    fill: "#dae1ed"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path",
    d: "M46.37 98.099a4.308 4.308 0 015.979 1.21 4.083 4.083 0 01-1.013 5.68l-.1.1a4.4 4.4 0 01-5.981-1.21 4.084 4.084 0 011.014-5.68c0-.1 0-.1.101-.1z",
    fill: "#dae1ed"
  })))));
}
export default SvgHexagonPaperSheet;